.Container {
  border-width: 0;
  border-radius: 0.6rem;
  width: 16rem;
  max-width: 16rem;
  height: 3.4rem;
  background-color: var(--color-secondary);
  color: var(--white-default);
  opacity: 1;
  display: flex;
  justify-content: space-between;
  gap: 0.8rem;
  align-items: center;
  padding: 0.8rem;
  cursor: grabbing;
}

.Text {
  color: var(--white-default);
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 1.8rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.Count {
  background-color: var(--white-default);
  border-radius: 0.3rem;
  padding: 0.4rem;
  color: var(--color-secondary);
  width: 2.4rem;
  height: 2.4rem;
  line-height: 1.8rem;
  font-size: 1.4rem;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
}
